import { sva } from "@filadd/phi-plus-styled-system/css";
export const menuItemRecipe = sva({
    slots: ["wrapper", "container", "icon", "text"],
    base: {
        icon: {
            minWidth: 4,
            flexShrink: 0,
            display: "inline-flex",
            justifyContent: "center",
        },
        text: {
            flex: "1 1 auto",
            ml: 2,
            my: 1,
            overflow: "hidden",
            minWidth: 0,
            fontSize: "sm",
            fontWeight: 500,
        },
        wrapper: {
            mt: 1,
            height: 11,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            textAlign: "left",
            overflow: "hidden",
            borderRadius: "lg",
            flexShrink: 0,
        },
        container: {
            width: "100%",
            outline: 0,
            border: 0,
            margin: 0,
            borderRadius: "lg",
            cursor: "pointer",
            userSelect: "none",
            verticalAlign: "middle",
            display: "flex",
            flexGrow: 1,
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            boxSizing: "border-box",
            textAlign: "left",
            px: 4,
            py: 2,
            bgColor: "transparent",
            transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            _hover: {
                textDecoration: "none",
                backgroundColor: "white.a3",
            },
            _disabled: {
                color: "fg.disabled",
                cursor: "not-allowed",
                "& :where(svg)": {
                    color: "fg.disabled",
                },
            },
        },
    },
    variants: {
        displayText: {
            true: {
                text: {
                    transition: "all 0.2s ease",
                    transitionDelay: "0.2s",
                    visibility: "visible",
                    opacity: "1",
                },
            },
            false: {
                text: {
                    transition: "none",
                    transitionDelay: "none",
                    visibility: "hidden",
                    opacity: "0",
                },
            },
        },
        isActive: {
            true: {
                wrapper: {
                    backgroundColor: "white.a3",
                },
            },
            false: {
                wrapper: {
                    backgroundColor: "transparent",
                },
            },
        },
        hasScrollbar: {
            true: {
                wrapper: {
                    mx: 1,
                },
            },
            false: {
                wrapper: {
                    mx: 2,
                },
            },
        },
        isExpanded: {
            true: {
                text: {
                    fontWeight: "bold",
                },
            },
            false: {},
        },
        hasChildren: {
            true: {
                wrapper: {
                    mx: 1,
                },
            },
            false: {},
        },
        asChild: {
            true: {
                wrapper: {
                    mx: 0,
                },
            },
            false: {},
        },
    },
});
//# sourceMappingURL=menuItemRecipe.js.map